import React from "react"
import CoreZoneLayer from "@/features/gis/CoreZoneLayer.jsx"
import { zoneValueLabel } from "@/utils/zoneLabels.js"

const rows = (p) => [
  p.name && [null, p.name],
  Array.isArray(p.pollutants) && p.pollutants.length && ["Pollutants", p.pollutants.join(", ")],
  p.status && ["Status", zoneValueLabel(p.status)],
  p.authority && ["Authority", p.authority],
]

export default function Eca(props) {
  return (
    <CoreZoneLayer
      flag="ECA"
      path="eca"
      title="ECA Area"
      style={{ fillColor: "green", color: "green", weight: 2 }}
      rows={rows}
      {...props}
    />
  )
}
